import SectionHeading from '@/components/feature/SectionHeading';
import { genres } from '@/mocks/genres';

interface GenreSectionProps {
  activeGenre: string;
  onSelectGenre: (genre: string) => void;
}

export default function GenreSection({ activeGenre, onSelectGenre }: GenreSectionProps) {
  const handleClick = (genre: string) => {
    onSelectGenre(genre);
    document.getElementById('recommend')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="genres" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="频道分类"
          title="按频道逛，点一下直接筛出对应作品"
          desc="每个频道都集合了一类气质相近的作品，点任意频道会跳到推荐区并自动筛选。不确定想看什么时，从频道入口随便逛逛往往更容易发现惊喜。"
        />

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
          {genres.map((g) => {
            const active = activeGenre === g.name;
            return (
              <button
                key={g.name}
                type="button"
                onClick={() => handleClick(g.name)}
                className={`text-left rounded-lg border p-4 md:p-5 cursor-pointer transition-colors ${
                  active
                    ? 'border-primary-500 bg-primary-50'
                    : 'border-background-200 bg-background-100 hover:border-primary-300 hover:bg-primary-50'
                }`}
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 text-xl">
                  <i className={g.icon}></i>
                </span>
                <h3 className="mt-3 font-heading text-base md:text-lg text-foreground-950">{g.name}</h3>
                <p className="mt-1 text-xs md:text-sm text-foreground-500">{g.note}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs text-primary-700">
                  <i className="ri-database-line"></i>
                  {g.count} 部作品
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}